import React from 'react';
import { Chip } from 'primereact/chip';

// @ts-ignore
import { ReactComponent as CloseSmallIcon } from '../../../assets/images/close_small-icon.svg';

interface Props {
    label: string;
    removable?: boolean;
    className?: string;
    onClick?: (e?: any) => void;
}

export const FilterChip: React.FC<Props> = ({ label, removable, className, onClick }) => (
    <Chip
        label={label}
        className={className}
        removable={removable}
        removeIcon={() => (
            <span key="remove-icon" className="ml-2 cursor-pointer">
                <CloseSmallIcon
                    onClick={() => {
                        if (removable && onClick) onClick();
                    }}
                />
            </span>
        )}
        onClick={(e: any) => {
            if (!removable && onClick) onClick(e);
        }}
    />
);